<div>
  <div class="hero"></div>
  <div>
    <div class="payment-container">
      <div>
        <h3>Update Billing</h3>

        <ng-container *ngIf="!user || pleaseWait">
          <div style="text-align: center;">
            <app-spinner></app-spinner>
            <br/>
            {{pleaseWaitMessage}}
          </div>
        </ng-container>
        <ng-container *ngIf="user && !pleaseWait">

          <!-- USER HAS A RENEWING GIFT MEMBERSHIP -->
          <ng-container *ngIf="!membershipGateway">
            Looks like you do not have an existing TYT membership.
            If you want to sign up for a membership, <a routerLink="/join">click here</a>.
          </ng-container>
          <ng-container *ngIf="membershipGateway == 'renewing-gift'">
            <div class="info-text">
              <div>
                <label class="key">Payment Type: </label>
                &nbsp;
                Renewing Gift
              </div>
            </div>
            <hr/>
            <p>Your membership is a renewing gift from {{user.membership.gift_item.purchaser_name}}.
              That user will have to update their payment information in order for your membership
              to renew properly.</p>
            <br/>
          </ng-container>

          <!-- USER IS ON FREE/PREPAID GATEWAY -->
          <ng-container *ngIf="membershipGateway == 'free'">
            <div class="info-text">
              <div>
                <label class="key">Payment Type: </label>
                &nbsp;
                Free / Complimentary
              </div>
            </div>
            <hr/>

            <p>Your membership is free, there is no payment information to update.</p>
          </ng-container>

          <!-- USER HAS A TIME-LIMITED GIFT MEMBERSHIP -->
          <ng-container *ngIf="membershipGateway == 'fixed-gift'">
            <div class="info-text">
              <div>
                <label class="key">Payment Type: </label>
                &nbsp;
                Fixed-Term Gift
              </div>
            </div>
            <hr/>

            <p>Your membership is a time-limited gift from {{user.membership.gift_item.purchaser_name}}.
            If you wish to purchase a paid membership, <a routerLink="/join">click here</a>.</p>
          </ng-container>

          <!-- USER IS ON PAYPAL GATEWAY -->
          <ng-container *ngIf="membershipGateway == 'paypal_agreement' || membershipGateway == 'paypal_subscription'">
            <div class="info-text">
              <div>
                <label class="key">Payment Type: </label>
                &nbsp;
                <ng-container *ngIf="membershipGateway == 'paypal_agreement'">PayPal</ng-container>
                <ng-container *ngIf="membershipGateway == 'paypal_subscription'">PayPal Classic</ng-container>
              </div>
            </div>
            <hr/>

            <div class="info-text">
              Because your current membership was purchased through PayPal, you must change your payment method on PayPal.com.
              To change your payment method, sign in to your <a target="_blank" href="https://paypal.com">PayPal Account</a> and
              click on ”Link a Bank or Card” under “Banks and Cards”.
              <br/><br/>
            </div>
          </ng-container>

          <!-- USER IS ON APPLE IAP GATEWAY -->
          <ng-container *ngIf="membershipGateway == 'iap_apple'">
            <div class="info-text">
              <div>
                <label class="key">Payment Type: </label>
                &nbsp;
                Apple Account
              </div>
            </div>
            <hr/>
            <p>Because your current membership was purchased through the iOS App Store, you can only change your payment method for
              TYT membership by changing your iTunes payment method.  To change your iTunes payment method, sign in to your
              <a target="_blank" href="https://buy.itunes.apple.com/WebObjects/MZFinance.woa/wa/DirectAction/manageSubscriptions">iOS
              App Store Account</a>, and then clicking on “Edit” next to Payment Type.</p>

            <p>Please see this <a target="_blank" href="https://support.apple.com/en-us/HT201266">Apple Support article</a> for more information.</p>
          </ng-container>

          <!-- USER IS ON GOOGLE PLAY GATEWAY -->
          <ng-container *ngIf="membershipGateway == 'google_play'">
            <div class="info-text">
              <div>
                <label class="key">Payment Type: </label>
                &nbsp;
                Google Account
              </div>
            </div>
            <hr/>
            <p>Because your current membership was purchased through the Google Play Store, you can only change your payment method for
              TYT membership by changing your Google Play payment method.   To change your Google Play payment method, sign in to your
              <a target="_blank" href="https://play.google.com/store/account/subscriptions">Google Play Store Account</a>, click on Account, and then click on Edit Payment Methods.</p>

            <p>Please see this <a target="_blank" href="https://support.google.com/googleplay/answer/4646404?co=GENIE.Platform%3DAndroid&hl=en">Google Play Support article</a>
              for more information.</p>
          </ng-container>

          <!-- USER IS STRIPE GATEWAY / IS UPDATING RENEWABLE GIFTS -->
          <ng-container *ngIf="membershipGateway == 'stripe'">
            <noscript>
              <br/>
              <div class="alert alert-danger">
                We use Javascript to send your credit card details directly to our credit card processor. This ensures that your credit card
                is handled securely. Please enable Javascript to update your billing details.
              </div>
              <br/>

              <div class="actions">
                <a class="btn btn-primary" routerLink="/billing/update">Try Again</a>
                <a class="btn btn-primary" routerLink="/account">Cancel</a>
              </div>

              <style>
                .not-noscript { display: none; }
              </style>
            </noscript>
            <div *ngIf="clientLoaded">
              <div class="info-text">
                <div>
                  <label class="key">Current Card: </label>
                  <ng-container *ngIf="!paymentSource">
                    No card on file
                  </ng-container>
                  <ng-container *ngIf="paymentSource">
                    <ng-container *ngIf="paymentSource.tokenization_method == 'apple_pay'">
                      [Apple Pay]
                    </ng-container>
                    {{paymentSource.brand}}
                    / {{paymentSource.last4}}
                  </ng-container>
                </div>
              </div>

              <div *ngIf="ownMembershipIsStripe">
                * This will update the billing method for your own membership
                and for any renewing gifts you may have purchased.
              </div>
              <div *ngIf="!ownMembershipIsStripe">
                * <strong>Please note:</strong> This will update the billing method for any renewing
                gifts you may have purchased. <strong>You must update billing for your
                own membership separately</strong> by using the option 'Update billing for my own membership'
                below.
              </div>

              <hr/>

              <div *ngIf="stripePaymentMethod == 'apple_pay'">
                <div class="info-text">
                  <div *ngIf="applePayAvailable">
                    Click the Apple Pay logo to update the credit card used to renew your TYT membership.
                    <br/><br/>
                    <div style="text-align: center;">
                      <button type="button" class="apple-pay-button" (click)="updateWithApplePay()">
                        <i class="fa fa-apple" aria-hidden="true"></i>
                        <span>Pay</span>
                      </button>
                    </div>

                  </div>
                  <div *ngIf="!applePayAvailable">
                    You are currently paying via Apple Pay but <strong>Apple Pay is not available on this
                      browser/device.</strong> To update the credit card used to renew your TYT
                      membership, please log in to your TYT account from Safari on an iOS or macOS
                      device which is enrolled in Apple Pay.
                  </div>
                </div>

                <hr/>
                Other Options:
                <button (click)="stripePaymentMethod = 'credit_card'" class="btn cancel">Pay With Credit Card Instead</button>
              </div>
              <div *ngIf="stripePaymentMethod == 'credit_card'">
                <error-message [producer]="this"></error-message>
                <app-form #form [handler]="this" class="script-off" [class.script-off]="false" action="/billing/update" [handler]="this">
                  <error-message></error-message>

                  <div class="form-payment">
                    <div class="card-payment">
                      <div class="payment-method">
                        <p>Payment Method</p>

                        <div class="cc-icons">
                          <i class="fa fa-cc-amex" aria-hidden="true"></i>
                          <i class="fa fa-cc-visa" aria-hidden="true"></i>
                          <i class="fa fa-cc-mastercard" aria-hidden="true"></i>
                          <i class="fa fa-cc-discover" aria-hidden="true"></i>
                        </div>

                      </div>

                      <div class="form-group">
                        <label for="cardholder-name">Cardholder Name</label>
                        <input errorHighlight type="text" class="form-control" id="cardholder-name" name="cardholder-name" [(ngModel)]="cardholderName"
                          required>
                      </div>
                      <div class="form-group credit-card">
                        <i *ngIf="cardBrandIcon" class="fa fa-{{cardBrandIcon || 'credit-card'}} brand" aria-hidden="true"></i>
                        <label for="cc-number">Credit Card Number</label>
                        <input #ccElement errorHighlight type="text" class="form-control" id="cc-number" name="cc-number" autocomplete="cc-number"
                          (change)="updateCardBrand()" (keyup)="updateCardBrand()" [(ngModel)]="creditCard">
                      </div>

                      <div class="card-exp-cvc">

                        <div class="form-group expiration">
                          <label for="expiration">Expiration</label>
                          <input errorHighlight type="text" placeholder="MM/YYYY" class="form-control" name="cc-exp" [(ngModel)]="expiration" required title="Make sure to include the slash between the month and the year">
                        </div>

                        <div class="form-group cvc">
                          <label for="cvc">CVC</label>
                          <input errorHighlight type="text" class="form-control" name="cc-csc" [(ngModel)]="cvc" required placeholder="CVC">

                          <a href="https://www.cvvnumber.com/cvv.html" target="_blank" class="card-tooltip">What is this?
                            <span class="tooltiptext">
                              The CVV Number ("Card Verification Value") on your credit card or debit card is a 3 digit number on VISA®, MasterCard® and
                              Discover® branded credit and debit cards. On your American Express® branded credit or debit card it is a 4 digit
                              numeric code.
                            </span>
                          </a>
                        </div>

                        <div class="form-group zipcode">
                          <label for="zipcode">Zipcode</label>
                          <input errorHighlight type="text" class="form-control" name="cc-zipcode" [(ngModel)]="address_zip" required placeholder="Zipcode">
                        </div>

                      </div>

                    </div>

                    <div class="edit-email-btns">
                      <app-form-submit-button type="submit" >Update Billing</app-form-submit-button>
                      <a href="javascript:;" (click)="cancelUpdateInfo()">cancel</a>
                    </div>
                  </div>

                </app-form>
                <hr/>
                Other Options:
                <button *ngIf="applePayAvailable || payingWithApplePay" (click)="switchStripeMethod('apple_pay')" class="btn cancel">Pay with Apple Pay instead</button>

              </div>
            </div>
          </ng-container>

          <a routerLink="/account" class="btn cancel">Back to My Account</a>
          <ng-container *ngIf="!ownMembershipIsStripe">
            <a *ngIf="!updateForGifts" href="javascript:;" (click)="updateForGifts = true" class="btn cancel">Update billing for gifts I've purchased</a>
            <a *ngIf="updateForGifts" href="javascript:;" (click)="updateForGifts = false" class="btn cancel">Update billing for my own membership</a>
          </ng-container>
        </ng-container>
      </div>
      
      <br/>

      <tyt-staging-note>
        <ul>
          <li><strong>Simulated Gateways</strong>
            <ul>
              <li><a href="javascript:;" (click)="user.membership.gateway_name = 'stripe'; user.membership.gift_item = null">Stripe (Non-Gift)</a></li>
              <li><a href="javascript:;" (click)="user.membership.gateway_name = 'stripe'; user.membership.gift_item = { purchaser_name: 'John Doe' }">Stripe (Renewing Gift)</a></li>
                <li><a href="javascript:;" (click)="user.membership.gateway_name = 'paypal_subscription'">PayPal Classic</a></li>
                <li><a href="javascript:;" (click)="user.membership.gateway_name = 'paypal_agreement'">PayPal</a></li>
                <li><a href="javascript:;" (click)="user.membership.gateway_name = 'iap_apple'">Apple IAP</a></li>
                <li><a href="javascript:;" (click)="user.membership.gateway_name = 'google_play'">Google Play</a></li>
                <li><a href="javascript:;" (click)="user.membership.gateway_name = 'free'">Free / Complimentary</a></li>
            </ul>
          </li>
        </ul>
      </tyt-staging-note>
    </div>
  </div>
</div>
